export default __webpack_public_path__ + "013446ce1915e9f29385b72764afe834.png";